import React, { createContext, useContext, useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { baseurl } from '../functions/api';
import { useStore } from '../Components/StateProvider';
import { getlocal } from '../functions/localstorage';

const SignalRContext = createContext();

export const useSignalR = () => useContext(SignalRContext);

export const SignalRProvider = ({ children }) => {
  const user = getlocal("system")?.user || {};
  const [showCelebration, setShowCelebration] = useState(false);
  const store = useStore();
  

  useEffect(() => {
    if (!user.id) return;

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(baseurl + `/charts?userId=${user.id}`) // Your SignalR hub URL
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connection.start()
      .then(() => {
        console.log("SignalR connected");

        connection.on("chartStation1", (data) => {
          console.log("Received from chartStation1:", data);
          setShowCelebration(true);
          // Hide celebration after a few seconds
          //setTimeout(() => setShowCelebration(false), 5000);
        });
        connection.on("TaskApproved", (data) => {
          console.log(" Received TaskApproved", data);
          console.log("My user ID:", user.id);
        
          if (data.assignedTo === user.id) {
            setShowCelebration(true);
          }
        });

        connection.on("badgecount",(data)=>{
          console.log("badges earned",data.badgecount)
          store.setsystemvalue("badgecount", data.badgecount);

        })

        connection.on("NotificationReceived", (notification) => {
          const currentNotifications = getlocal("system")?.Notification || [];
          store.setsystemvalue("Notification", [notification, ...currentNotifications]);
        });

        connection.on("UnreadNotificationCountChanged", (data) => {
          store.setsystemvalue("UnreadNotificationCount", data?.unreadCount || 0);
        });
        
        connection.on("chartStatus2", (data) => {
          console.log("📡 Received from chartStatus2:", data);
        });
      })
      .catch(err => console.error("SignalR connection error:", err));

    return () => {
      connection.stop();
    };
  }, [user.id]);

  return (
    <SignalRContext.Provider value={{ showCelebration }}>
      {children}
    </SignalRContext.Provider>
  );
};
